<template>
    <div class="alphabet-sort">
      <ul>
        <li  v-on:click="showExhibitors(0)" ><a href="" :class="{ active: selectedAlphabet === '0' }">All</a>
        </li>
        <li v-for="a in alphabet" v-bind:key="a.Id" v-on:click="showExhibitors(a)" ><a :class="{ active: selectedAlphabet === a }">{{ a }}</a> </li>

      </ul>
    </div>
</template>
<script>
export default {
  name: "AlphaNumericFilter",
  data: function () {
    return {
      alphabet: "abcdefghijklmnopqrstuvwxyz".split(""),
      selectedAlphabet: '0'  // Default to 'All'
    };
  },
  methods: {
    showExhibitors: function (alphabet) {
      this.selectedAlphabet = alphabet;
      if (alphabet == "number") {
        this.$store.dispatch("exhibitorNumericList");
      } else if (alphabet == "0") {
        this.$emit("viewAll");
        this.$store.dispatch("exhibitorViewAllList");
      } else {
        this.$emit("viewAll");
        this.$store.dispatch("exhibitorAlphabeticList", alphabet);
      }
    }
  }
};
</script>
<style>
</style>
